// extracted by mini-css-extract-plugin
export default {"abaTextInputLabel":"ABATextInput_abaTextInputLabel__w796b","abaTextInputErrorMessage":"ABATextInput_abaTextInputErrorMessage__4VACx"};